<div class="row email-container align-items-center flex-column pb-20">
  <div class="col-12 mt-20 top-section d-flex align-items-center flex-column" [@fadeAnimation]>
    <div class="text-center w-100">
      <h3 [innerHTML]="title"></h3>
      <!-- <div class="subtitle mt-20">{{ subtitle }}</div>         -->
    </div>

    @if (!isShortFlow) {
      <div
        class="gift-box mt-20 w-100 border-radius d-flex bg-light-green-color align-items-center"
      >
        <div class="gift-icon"></div>
        <div class="gift-label" i18n="@@claimPersonalPlanBonus">
          Claim your personal plan with a Bonus before it's gone!
        </div>
      </div>
    }

    <div class="tagus-form-group mt-24 w-100">
      <mat-form-field appearance="fill">
        <i class="ri-mail-line"></i>
        <input
          #emailInput
          matInput
          autocomplete="email"
          i18n-placeholder="@@enterYourEmail"
          placeholder="Enter your email"
          type="email"
          [formControl]="email"
          [matAutocomplete]="auto"
          (keyup.enter)="enterPressed()"
          required
        />

        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayEmail"
          (optionSelected)="onSuggestionSelected($event.option.value)"
        >
          @for (suggestion of filteredDomains$ | async; track suggestion) {
            <mat-option [value]="suggestion">
              <span>{{ suggestion }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <button
      mat-flat-button
      class="tagus mt-5"
      [disabled]="email.invalid"
      (click)="continueButtonClicked()"
    >
      <ng-container i18n="@@continue">Continue</ng-container>
    </button>

    <div class="muted-color fs-12 mt-32 text-center">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.52745 1.02719C2.84267 1.71227 2.50013 2.53657 2.50013 3.49996V6L2.25003 5.99992C2.04182 5.99992 1.86462 6.07288 1.71872 6.21876C1.57296 6.36465 1.5 6.5417 1.5 6.74977V11.2499C1.5 11.4584 1.57296 11.6353 1.71872 11.7812C1.86462 11.9271 2.04182 12 2.25003 12H9.74994C9.95844 12 10.1355 11.9271 10.2812 11.7812C10.4271 11.6353 10.4999 11.4584 10.4999 11.2499V6.7498C10.4999 6.54157 10.4271 6.36465 10.2812 6.21876C10.1355 6.07286 9.9583 5.99992 9.74994 5.99992H9.49993V3.49996C9.49993 2.53657 9.15753 1.71227 8.47259 1.02719C7.78778 0.342382 6.96363 0 5.99997 0C5.03647 0 4.2123 0.342382 3.52745 1.02719ZM5.41272 9.12141V10.5889C5.41272 10.8846 5.6525 11.1244 5.94823 11.1244H6.05165C6.34738 11.1244 6.58716 10.8846 6.58716 10.5889V9.12141C6.90153 8.92503 7.11138 8.57694 7.11138 8.17899C7.11138 7.56509 6.61369 7.06756 5.99993 7.06756C5.38617 7.06756 4.88849 7.56525 4.88849 8.17899C4.88851 8.57707 5.09838 8.92519 5.41272 9.12141ZM5.9999 1.5C4.89396 1.5 3.99743 2.39654 3.99743 3.50247V6H8.00237V3.50247C8.00237 2.39654 7.10583 1.5 5.9999 1.5Z"
        ></path>
      </svg>
      <ng-container i18n="@@privacyCommitment">
        We respect your privacy and we are committed to protecting your personal data.
      </ng-container>
    </div>

    <!-- <div class="separator">
    <div class="left-line"></div>
    <div class="or-label">or</div>
    <div class="right-line"></div>
  </div>
  <button class="apple-button" (click)="appleClicked()"><div class="apple-icon"></div>&nbsp;Sign In with Apple</button> -->
  </div>
</div>
